import { breakpoint, colors, fontFamily, fontSize, fontWeight, mediaQueryHelper } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  container: css({
    display: 'flex',
    flexDirection: 'column',

    [mediaQueryHelper(breakpoint.tablet)]: {
      flexDirection: 'row',
    },
  }),

  filtersWrapper: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%',

    [mediaQueryHelper(breakpoint.tablet)]: {
      flexDirection: 'row',
      alignItems: 'stretch',
      width: '100%',
    },
  }),

  searchButton: css({
    height: '45px !important',
    width: '100%',
    fontSize: fontSize.default,
    fontWeight: `${fontWeight.medium} !important`,
    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.small,
    },
    [mediaQueryHelper(breakpoint.tablet)]: {
      width: 'auto',
    },
  }),

  searchButtonWrapper: css({
    display: 'flex',
    alignItems: 'flex-end',
    marginTop: 0,
    [mediaQueryHelper(breakpoint.tablet)]: {
      marginTop: 23,
    },
  }),

  clearSearchLinkMobile: css({
    position: 'relative',
    display: 'inline-flex',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.default,
    lineHeight: '19px',
    color: colors.cornflowerBlue,
    margin: '24px auto 0 auto',
    textDecoration: 'underline',

    [mediaQueryHelper(breakpoint.tablet)]: {
      display: 'none',
    },
  }),

  clearSearchLinkDesktop: css({
    position: 'relative',
    cursor: 'pointer',
    display: 'none',
    whiteSpace: 'nowrap',
    fontWeight: fontWeight.semiBold,
    fontSize: fontSize.small,
    lineHeight: '17px',
    color: colors.cornflowerBlue,
    padding: '12px 0',
    marginLeft: '12px',

    [mediaQueryHelper(breakpoint.tablet)]: {
      display: 'inline-flex',
    },
  }),

  advancedFilters: css({
    display: 'none',
    fontSize: fontSize.small,
    width: 'auto',
    cursor: 'pointer',
    color: colors.jumbo,
    marginBottom: 0,

    img: {
      marginLeft: '5px',
      marginBottom: '1px',
      width: '10px',
    },

    span: {
      fontWeight: fontWeight.semiBold,
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      display: 'flex',
      alignItems: 'end',
      justifyContent: 'flex-start',
      fontWeight: fontWeight.medium,
      marginTop: '24px',
    },
  }),

  modal: css({
    width: '290px',
    right: 0,
    left: 'unset',
    top: 'calc(100% + 6px)',
    [mediaQueryHelper(breakpoint.phone)]: {
      width: '350px',
      left: '0',
    },

    [mediaQueryHelper(breakpoint.tablet)]: {
      left: 'unset',
    },
  }),

  popUp: css({
    padding: '14px',
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    color: colors.blackPearl,
    lineHeight: '140%',
    fontWeight: fontWeight.regular,

    p: {
      margin: 0,
    },

    a: {
      textDecoration: 'underline',
      color: colors.cornflowerBlue,
      cursor: 'pointer',
      fontWeight: fontWeight.bold,
    },
  }),
}

export default styles
